import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDeviceType } from "@vfit/shared/hooks";
import { MenuUnderlay, WrapperContainer } from "./header.style";
import Head from "./components/Head/head";
import Body from "./components/Body/body";
import Footer from "./components/Footer/footer";
import { useMenu } from "./header.utils";
import HeaderMobile from "./HeaderMobile/headerMobile";
import { MainContainer } from "./HeaderMobile/headerMobile.style";
import HeaderLite from "./HeaderLite/HeaderLite";
var Header = function(param) {
    var lite = param.lite, litePadding = param.litePadding, header = param.header, onTrack = param.onTrack, _disablePaddingTop = param.disablePaddingTop, disablePaddingTop = _disablePaddingTop === void 0 ? false : _disablePaddingTop;
    var ref = useState(0), headerHeight = ref[0], setHeaderHeight = ref[1];
    var head = header.head, body = header.body;
    var ref1 = useMenu(), firstLevelState = ref1.menuState, setFirstLevelState = ref1.setMenuState;
    var ref2 = useMenu(), secondLevelState = ref2.menuState, setSecondLevelState = ref2.setMenuState;
    var ref3 = body || {}, menuType = ref3.menuType, actionsMenu = ref3.actionsMenu;
    var headHeight = useRef(0);
    var bodyHeight = useRef(0);
    var ref4 = useDeviceType(), isDesktop = ref4.isDesktop, isTablet = ref4.isTablet;
    var handlerHeadHeight = useCallback(function(height) {
        headHeight.current = height;
    }, []);
    var handlerBodyHeight = useCallback(function(height) {
        bodyHeight.current = height;
    }, []);
    useEffect(function() {
        if (isDesktop && !isTablet) {
            setHeaderHeight(headHeight.current + bodyHeight.current);
        } else {
            setHeaderHeight(headHeight.current);
        }
    }, [
        headHeight,
        bodyHeight,
        headerHeight,
        isDesktop,
        isTablet
    ]);
    useEffect(function() {
        if (litePadding) {
            var ref;
            var firstChild = document.getElementsByTagName("header");
            var firstSiblingElement = firstChild === null || firstChild === void 0 ? void 0 : (ref = firstChild[0]) === null || ref === void 0 ? void 0 : ref.nextElementSibling;
            if (firstSiblingElement) firstSiblingElement.style.cssText = "padding-top: ".concat(isDesktop || isTablet ? "135px" : "95px", " !important");
        }
    }, [
        litePadding,
        isDesktop,
        isTablet
    ]);
    if (lite || litePadding) return /*#__PURE__*/ _jsx(HeaderLite, {
        isLite: !!lite,
        disablePaddingTop: disablePaddingTop,
        pt: headerHeight
    });
    return isDesktop && !isTablet ? /*#__PURE__*/ _jsxs(WrapperContainer, {
        id: "mainHeader",
        pt: headerHeight,
        disablePaddingTop: disablePaddingTop,
        children: [
            /*#__PURE__*/ _jsxs("nav", {
                children: [
                    /*#__PURE__*/ _jsx(Head, {
                        getContainerHeight: handlerHeadHeight,
                        customerType: head === null || head === void 0 ? void 0 : head.customerType,
                        otherInfo: head === null || head === void 0 ? void 0 : head.otherInfo,
                        onTrack: onTrack
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        onMouseLeave: function() {
                            setFirstLevelState(function(prevData) {
                                return _object_spread_props(_object_spread({}, prevData), {
                                    isHovered: false
                                });
                            });
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Body, {
                                getContainerHeight: handlerBodyHeight,
                                menuType: menuType,
                                actionsMenu: actionsMenu,
                                openMenu: setFirstLevelState,
                                isFirstLevelMenuOpen: firstLevelState,
                                onTrack: onTrack,
                                headerLogo: body === null || body === void 0 ? void 0 : body.headerLogo
                            }),
                            /*#__PURE__*/ _jsx(Footer, {
                                menuType: menuType,
                                isFirstLevelMenuOpen: firstLevelState,
                                isSecondLevelMenuOpen: secondLevelState,
                                openSecondLevelMenu: setSecondLevelState,
                                onTrack: onTrack
                            })
                        ]
                    })
                ]
            }),
            firstLevelState.isHovered && /*#__PURE__*/ _jsx(MenuUnderlay, {})
        ]
    }) : /*#__PURE__*/ _jsx(MainContainer, {
        id: "mainHeader",
        pt: headerHeight,
        children: /*#__PURE__*/ _jsx(HeaderMobile, {
            header: {
                head: head,
                body: body,
                getContainerHeight: handlerHeadHeight
            },
            onTrack: onTrack
        })
    });
};
export default Header;
